import Checkbox from '@/components/shared/Checkbox';
import { selectInputWhenFocussed } from '@/utils/selectInputWhenFocussed';
import clsx from 'clsx';
import { forwardRef, InputHTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type TProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'title'> & {
  selected?: boolean;
  memberName?: string;
};

const SignatureComponent = forwardRef<
  HTMLInputElement,
  PropsWithChildren<TProps>
>((props, ref) => {
  const { memberName, selected, children, className, ...rest } = props;

  const isSigned = selected || rest.checked;

  return (
    <div
      className={twMerge('flex flex-col items-stretch select-none', className)}
    >
      <div className="flex items-center justify-between relative">
        <label
          htmlFor={rest.id}
          tabIndex={0}
          onKeyUp={selectInputWhenFocussed(rest.id ?? '')}
          className="cursor-pointer"
        >
          <Checkbox className="absolute !w-0" ref={ref} {...rest} icon={null} />
          <span
            className={clsx({
              'text-[32px] !font-satisfy text-gray-300': true,
              'text-gray-600': isSigned,
            })}
          >
            {memberName}
          </span>
        </label>
        {children}
      </div>
      <hr className="my-4 border-t-2 w-full border-dashed border-secondary-200" />
      <p className="text-gray-500 font-medium text-sm font-body">
        Click above to sign <span className="text-primary-600">*</span>
      </p>
    </div>
  );
});

export default SignatureComponent;
